import { TopupsModel } from '@/entities/topups'
import { useTopupsQuery } from '@/entities/topups/hooks/useTopupsQuery'
import { TableTemplate } from '@/features/baseTable'
import { CardTableSkeleton } from '@/features/baseTable/ui/CardTableSkeleton'
import { BaseCard } from '@/shared/components'
import { FilterButton } from '@/shared/components/FilterButton/FilterButton'
import { FilterButtonModel } from '@/shared/components/MobileFilterButtons/MobileFilterButtons'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { traderTopupsColumns } from './model'

const filterButtons: FilterButtonModel[] = [
  { name: 'Все', label: 'all', index: 1 },
  { name: 'Платеж выполняется', label: 'waiting', index: 2 },
  { name: 'Завершенные', label: 'paid', index: 3 },
  { name: 'Отмененные', label: 'canceled', index: 4 },
]

export const TraderTopupsCard = () => {
  const [selected, setSelected] = useState(1)

  const handleFilterClick = (button: FilterButtonModel) => {
    setSelected(button.index)
  }

  const { data, error, isLoading } = useTopupsQuery({
    skip: 0,
    take: 10,
    status: selected,
  })

  return (
    <BaseCard className="w-full" variant="secondary" radius="lg">
      <div className="flex justify-between items-center mb-4 md:mb-6">
        <h3>Входящие заявки</h3>
        <Link to="/deals" className="text-primary dark:text-primary-dark text-sm">
          Показать все
        </Link>
      </div>
      <div className="flex gap-0.5 mb-5 p-0.5 overflow-x-auto scrollbar-hide">
        {filterButtons.map((b) => (
          <FilterButton
            key={b.index}
            name={b.name}
            onClick={() => handleFilterClick(b)}
            selected={b.index === selected}
            padding="sm"
          />
        ))}
      </div>
      {error ? (
        <p>Ошибка загрузки данных.</p>
      ) : isLoading ? (
        <CardTableSkeleton />
      ) : !data?.items || data?.items.length === 0 ? (
        <p>Данных нет.</p>
      ) : (
        <div className="pr-2 max-h-[240px] overflow-auto custom-scrollbar">
          <TableTemplate columns={traderTopupsColumns} data={data.items as TopupsModel[]} />
        </div>
      )}
    </BaseCard>
  )
}
